module.exports = __webpack_public_path__ + "img/img29.84920a45.jpg";